module.exports = __webpack_public_path__ + "img/E6E6E6_AAAAAA_C4C4C4_CCCCCC-256px.a61a840e.png";